/*
|--------------------------------------------------------------------------
| Views: Featured Video
|--------------------------------------------------------------------------
*/

/**
 * Featured Video
 * @namespace
 */
__gh__webApp.views.featuredVideo = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},

	"getSubView": function(bucket){
		var thirdPartyData 	= __gh__coreData["3rdPartyData"],
			toutID			= thirdPartyData.video.tout.id;

		bucket.toutID		= toutID;
		bucket.view.name 	= "buckets/featuredVideo/default";

		return bucket;
	}

};
